<script setup lang="ts">
import { GlassButton } from '~/components/GlassButton';

import IconMaterialSymbolsLightKeyboardArrowDown from '~icons/material-symbols-light/keyboard-arrow-down';
import IconMaterialSymbolsLightKeyboardArrowUp from '~icons/material-symbols-light/keyboard-arrow-up';

interface ShortsDesktopActionsProps {
	canGoPrevious: boolean;
	canGoNext: boolean;
}

defineProps<ShortsDesktopActionsProps>();

defineEmits<{
	(e: 'go-previous'): void;
	(e: 'go-next'): void;
}>();
</script>

<template>
	<div
		class="hidden lg:flex lg:flex-col lg:items-start lg:justify-between lg:self-stretch lg:pl-7 lg:relative xl:pr-0 lg:pr-6 xl:pl-0 2xl:pr-0"
	>
		<div
			class="absolute right-0 top-1/2 flex -translate-y-1/2 flex-col items-center gap-3 lg:pt-20 lg:pr-6 xl:pr-0 2xl:pr-0"
		>
			<GlassButton
				variant="action"
				size="lg"
				class="shrink-0"
				:disabled="!canGoPrevious"
				aria-label="Anterior"
				@click="$emit('go-previous')"
			>
				<IconMaterialSymbolsLightArrowUpward class="size-7 text-white" />
			</GlassButton>

			<GlassButton
				variant="action"
				size="lg"
				class="shrink-0"
				:disabled="!canGoNext"
				aria-label="Próximo"
				@click="$emit('go-next')"
			>
				<IconMaterialSymbolsLightArrowDownward class="size-7 text-white" />
			</GlassButton>
		</div>

		<slot />
	</div>
</template>
